import { cn } from '@workspace/ui/lib/utils'
import { Lock } from 'lucide-react'
import type { ReactNode } from 'react'

/** One card of the startup panel or page: the same box and heading in both. */
export function RelCard({
  title,
  right,
  className,
  children,
}: {
  title: string
  /** What sits at the right of the heading (a status, a date, "Private"). */
  right?: ReactNode
  className?: string
  children: ReactNode
}) {
  return (
    <section
      className={cn(
        'overflow-hidden rounded-xl border border-border bg-card/30 p-4 text-foreground',
        className
      )}
    >
      <div className="flex items-center justify-between gap-3">
        <h2 className="text-sm font-semibold">{title}</h2>
        {right}
      </div>
      {children}
    </section>
  )
}

/** The lock and "Private" the assistant's read and the investor's own note carry. */
export function PrivateTag({ label }: { label: string }) {
  return (
    <span className="inline-flex items-center gap-1 text-xs text-muted-foreground">
      <Lock className="size-3" />
      {label}
    </span>
  )
}
